import {Component, EventEmitter, input, model, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {ScreenService} from "@core/services/screen.service";
import {takeUntil} from "rxjs/operators";
import {NgbPagination, NgbPaginationNext, NgbPaginationPrevious} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {DecimalPipe} from "@angular/common";

@Component({
    selector: 'app-pagination',
    templateUrl: './app-pagination.component.html',
    styleUrls: ['./app-pagination.component.scss'],
    imports: [
        NgbPagination,
        FormsModule,
        NgbPaginationPrevious,
        NgbPaginationNext,
        TranslateModule,
        DecimalPipe
    ],
    standalone: true
})
export class AppPaginationComponent implements OnInit, OnDestroy {

    show = input(true);

    itemsAmount = input(0);

    currentPage = input(0);

    itemsPerPage = model(0);

    @Output()
    onPaginate: EventEmitter<any> = new EventEmitter();

    @Output()
    onChangeItemsPerPage: EventEmitter<number> = new EventEmitter();

    itemsPerPageList: number[] = [10, 20, 25, 50];
    maxSize: number = 10;

    readonly unsub$ = new Subject<void>();

    constructor(private screenService: ScreenService) {
    }

    ngOnInit(): void {
        this.detectScreenSize();
    }

    paginate(ev: any) {
        this.onPaginate.emit(ev);
    }

    changeItemsPerPage(ev: number) {
        this.onChangeItemsPerPage.emit(Number(ev));
    }

    ngOnDestroy(): void {
        this.unsub$.next();
        this.unsub$.complete();
    }

    private detectScreenSize(): void {
        this.screenService.isBelowSm()
            .pipe(takeUntil(this.unsub$))
            .subscribe((isBelowSm: { matches: any; }) => {
                this.maxSize = isBelowSm?.matches ? 3 : 7;
            });
    }
}
